import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var palette = {
  /** Brand */
  brandPrimary: '#5B53FF',
  brandLight: '#7770ff',
  brandDark: '#403AB3',
  brandPrimaryAlpha: 'rgba(91, 83, 255, 0.25)',

  /** Greys */
  grey00: 'hsl(0, 0%, 0%)',
  grey05: 'hsl(240, 22%, 3%)',
  grey10: 'hsl(232, 20%, 9%)',
  grey12: 'hsl(234, 20%, 12%)',
  grey15: 'hsl(235, 18%, 15%)',
  grey20: 'hsl(236, 16%, 20%)',
  grey30: 'hsl(237, 16%, 27%)',
  grey40: 'hsl(234, 12%, 43%)',
  grey50: 'hsl(233, 9%, 48%)',
  grey60: 'hsl(233, 10%, 58%)',
  grey70: 'hsl(235, 10%, 68%)',
  grey80: 'hsl(232, 9%, 78%)',
  grey90: 'hsl(240, 11%, 88%)',
  grey100: 'hsl(99, 100%, 100%)',

  /** White alpha scale */
  whiteA00: 'rgba(255, 255, 255, 0.02)',
  whiteA05: 'rgba(255, 255, 255, 0.04)',
  whiteA10: 'rgba(255, 255, 255, 0.08)',
  whiteA15: 'rgba(255, 255, 255, 0.12)',
  whiteA20: 'rgba(255, 255, 255, 0.15)',
  whiteA30: 'rgba(255, 255, 255, 0.2)',
  whiteA40: 'rgba(255, 255, 255, 0.3)',
  whiteA50: 'rgba(255, 255, 255, 0.4)',
  whiteA60: 'rgba(255, 255, 255, 0.5)',
  whiteA70: 'rgba(255, 255, 255, 0.6)',
  whiteA80: 'rgba(255, 255, 255, 0.7)',
  whiteA90: 'rgba(255, 255, 255, 0.8)',
  whiteA100: 'rgba(255, 255, 255, 1)',

  /** Tint alpha scale */
  tintA100: 'rgba(255,255,255,1)',
  tintA90: 'rgba(246, 246, 248, 0.9)',
  tintA80: 'rgba(240, 241, 244, 0.8)',
  tintA70: 'rgba(217, 218, 227, 0.75)',
  tintA60: 'rgba(188, 190, 210, 0.7)',
  tintA50: 'rgba(163, 165, 184, 0.65)',
  tintA40: 'rgba(163, 166, 194, 0.55)',
  tintA30: 'rgba(93, 96, 126, 0.5)',
  tintA20: 'rgba(77, 79, 102, 0.4)',
  tintA15: 'rgba(56, 57, 77, 0.35)',
  tintA10: 'rgba(43, 44, 59, 0.3)',
  tintA05: 'rgba(33, 35, 48, 0.2)',
  tintA00: 'rgba(11, 12, 14, 0.1)',

  /** Tint */
  // Orange
  orange900: 'rgba(255,96,87,0.15)',
  orange800: 'rgba(255,96,87,0.3)',
  orange700: 'rgba(255,96,87,0.6)',
  orange600: 'rgba(255,96,87,0.8)',
  orange500: 'rgba(255,96,87,1)',
  orange400: 'rgba(255,110,102,1)',
  orange300: 'rgba(255,134,128,1)',
  orange200: 'rgba(255,158,153,1)',
  orange100: 'rgba(255,183,179,1)',
  // Gold
  gold900: 'rgba(255,157,66,0.15)',
  gold800: 'rgba(255,157,66,0.3)',
  gold700: 'rgba(255,157,66,0.6)',
  gold600: 'rgba(255,157,66,0.8)',
  gold500: 'rgba(255,157,66,1)',
  gold400: 'rgba(255,175,102,1)',
  gold300: 'rgba(255,189,128,1)',
  gold200: 'rgba(255,202,153,1)',
  gold100: 'rgba(255,215,179,1)',
  // Yellow
  yellow900: 'rgba(249,197,11,0.15)',
  yellow800: 'rgba(249,197,11,0.3)',
  yellow700: 'rgba(249,197,11,0.6)',
  yellow600: 'rgba(249,197,11,0.8)',
  yellow500: 'rgba(249,197,11,1)',
  yellow400: 'rgba(251,220,106,1)',
  yellow300: 'rgba(252,225,131,1)',
  yellow200: 'rgba(253,231,155,1)',
  yellow100: 'rgba(253,237,180,1)',
  // Green
  green900: 'rgba(37,192,109,0.15)',
  green800: 'rgba(37,192,109,0.3)',
  green700: 'rgba(37,192,109,0.6)',
  green600: 'rgba(37,192,109,0.8)',
  green500: 'rgba(37,192,109,1)',
  green400: 'rgba(40,205,117,1)',
  green300: 'rgba(63,218,135,1)',
  green200: 'rgba(105,226,161,1)',
  green100: 'rgba(140,233,183,1)',
  // Teal
  teal900: 'rgba(44,201,182,0.15)',
  teal800: 'rgba(44,201,182,0.3)',
  teal700: 'rgba(44,201,182,0.6)',
  teal600: 'rgba(44,201,182,0.8)',
  teal500: 'rgba(44,201,182,1)',
  teal400: 'rgba(58,212,193,1)',
  teal300: 'rgba(88,218,203,1)',
  teal200: 'rgba(130,227,216,1)',
  teal100: 'rgba(150,232,222,1)',
  // SkyBlue
  skyBlue900: 'rgba(92,208,255,0.15)',
  skyBlue800: 'rgba(92,208,255,0.3)',
  skyBlue700: 'rgba(92,208,255,0.6)',
  skyBlue600: 'rgba(92,208,255,0.8)',
  skyBlue500: 'rgba(92,208,255,1)',
  skyBlue400: 'rgba(117,215,255,1)',
  skyBlue300: 'rgba(128,218,255,1)',
  skyBlue200: 'rgba(153,225,255,1)',
  skyBlue100: 'rgba(179,233,255,1)',
  // Blue
  blue900: 'rgba(66,160,255,0.15)',
  blue800: 'rgba(66,160,255,0.3)',
  blue700: 'rgba(66,160,255,0.6)',
  blue600: 'rgba(66,160,255,0.8)',
  blue500: 'rgba(66,160,255,1)',
  blue400: 'rgba(102,178,255,1)',
  blue300: 'rgba(128,191,255,1)',
  blue200: 'rgba(153,204,255,1)',
  blue100: 'rgba(179,217,255,1)',
  // Pink
  pink900: 'rgba(233,111,235,0.15)',
  pink800: 'rgba(233,111,235,0.3)    ',
  pink700: 'rgba(233,111,235,0.6)',
  pink600: 'rgba(233,111,235,0.8)',
  pink500: 'rgba(233,111,235,1)',
  pink400: 'rgba(235,120,237,1)',
  pink300: 'rgba(238,143,240,1)',
  pink200: 'rgba(241,165,243,1)',
  pink100: 'rgba(245,188,246,1)',
  // Purple
  purple900: 'rgba(167,97,255,0.15)',
  purple800: 'rgba(167,97,255,0.3)',
  purple700: 'rgba(167, 97, 255, 0.6)',
  purple600: 'rgba(167,97,255,0.8)',
  purple500: 'rgba(167,97,255,1)',
  purple400: 'rgba(170,102,255,1)',
  purple300: 'rgba(184,128,255,1)',
  purple200: 'rgba(198,153,255,1)',
  purple100: 'rgba(212,179,255,1)',
  // Alerts
  // Error
  alertError900: 'rgba(235,71,81,0.15)',
  alertError800: 'rgba(235,71,81,0.3)',
  alertError700: 'rgba(235,71,81,0.6)',
  alertError600: 'rgba(235,71,81,0.8)',
  alertError500: 'rgba(235,71,81,1)',
  alertError400: 'rgba(237,94,103,1)',
  alertError300: 'rgba(242,140,146,1)',
  alertError200: 'rgba(245,163,168,1)',
  alertError100: 'rgba(247,186,190,1)',
  // Success
  alertSuccess900: 'rgba(52,210,125,0.15)',
  alertSuccess800: 'rgba(52,210,125,0.3)',
  alertSuccess700: 'rgba(52,210,125,0.6)',
  alertSuccess600: 'rgba(52,210,125,0.8)',
  alertSuccess500: 'rgba(52,210,125,1)',
  alertSuccess400: 'rgba(88,218,148,1)',
  alertSuccess300: 'rgba(150,232,188,1)',
  alertSuccess200: 'rgba(171,237,201,1)',
  alertSuccess100: 'rgba(192,241,215,1)',
  // Warning
  alertWarning900: 'rgba(239,195,40,0.15)',
  alertWarning800: 'rgba(239,195,40,0.3)',
  alertWarning700: 'rgba(239,195,40,0.6)',
  alertWarning600: 'rgba(239,195,40,0.8)',
  alertWarning500: 'rgba(239,195,40,1)',
  alertWarning400: 'rgba(243,209,89,1)',
  alertWarning300: 'rgba(246,222,136,1)',
  alertWarning200: 'rgba(248,229,160,1)',
  alertWarning100: 'rgba(250,235,184,1)',
  //Vibrant
  vibrant0: 'rgba(235, 71, 71, 1)',
  vibrant10: 'rgba(235, 99, 71, 1)',
  vibrant20: 'rgba(235, 126, 71, 1)',
  vibrant30: 'rgba(251, 178, 106, 1)',
  vibrant40: 'rgba(235, 180, 71, 1)',
  vibrant50: 'rgba(235, 207, 71, 1)',
  vibrant60: 'rgba(235, 235, 71, 1)',
  vibrant70: 'rgba(207, 235, 71, 1)',
  vibrant80: 'rgba(180, 235, 71, 1)',
  vibrant90: 'rgba(153, 235, 71, 1)',
  vibrant100: 'rgba(126, 235, 71, 1)',
  vibrant110: 'rgba(99, 235, 71, 1)',
  vibrant120: 'rgba(71, 235, 71, 1)',
  vibrant130: 'rgba(71, 235, 98, 1)',
  vibrant140: 'rgba(71, 235, 126, 1)',
  vibrant150: 'rgba(71, 235, 153, 1)',
  vibrant180: 'rgba(71, 235, 235, 1)',
  vibrant190: 'rgba(71, 207, 235, 1)',
  vibrant200: 'rgba(71, 180, 235, 1)',
  vibrant220: 'rgba(71, 126, 235, 1)',
  vibrant230: 'rgba(71, 99, 235, 1)',
  vibrant240: 'rgba(71, 71, 235, 1)',
  vibrant250: 'rgba(99, 71, 235, 1)',
  vibrant260: 'rgba(126, 71, 235, 1)',
  vibrant270: 'rgba(153, 71, 235, 1)',
  vibrant280: 'rgba(180, 71, 235, 1)',
  vibrant290: 'rgba(207, 71, 235, 1)',
  vibrant300: 'rgba(235, 71, 235, 1)',
  vibrant310: 'rgba(235, 71, 207, 1)',
  vibrant320: 'rgba(235, 71, 180, 1)',
  vibrant330: 'rgba(235, 71, 153, 1)',
  vibrantA00: 'rgba(235, 71, 71, 0.5)',
  vibrantA10: 'rgba(235, 99, 71, 0.5)',
  vibrantA20: 'rgba(235, 126, 71, 0.5)',
  vibrantA30: 'rgba(251, 178, 106, 0.5)',
  vibrantA40: 'rgba(235, 180, 71, 0.5)',
  vibrantA50: 'rgba(235, 207, 71, 0.5)',
  vibrantA60: 'rgba(235, 235, 71, 0.5)',
  vibrantA70: 'rgba(207, 235, 71, 0.5)',
  vibrantA80: 'rgba(180, 235, 71, 0.5)',
  vibrantA90: 'rgba(153, 235, 71, 0.5)',
  vibrantA100: 'rgba(126, 235, 71, 0.5)',
  vibrantA110: 'rgba(99, 235, 71, 0.5)',
  vibrantA120: 'rgba(71, 235, 71, 0.5)',
  vibrantA130: 'rgba(71, 235, 98, 0.5)',
  vibrantA140: 'rgba(71, 235, 126, 0.5)',
  vibrantA150: 'rgba(71, 235, 153, 0.5)',
  vibrantA180: 'rgba(71, 235, 235, 0.5)',
  vibrantA190: 'rgba(71, 207, 235, 0.5)',
  vibrantA200: 'rgba(71, 180, 235, 0.5)',
  vibrantA210: 'rgba(71, 153, 235, 0.5)',
  vibrantA220: 'rgba(71, 126, 235, 0.5)',
  vibrantA230: 'rgba(71, 99, 235, 0.5)',
  vibrantA240: 'rgba(71, 71, 235, 0.5)',
  vibrantA250: 'rgba(99, 71, 235, 0.5)',
  vibrantA260: 'rgba(126, 71, 235, 0.5)',
  vibrantA270: 'rgba(153, 71, 235, 0.5)',
  vibrantA280: 'rgba(180, 71, 235, 0.5)',
  vibrantA290: 'rgba(207, 71, 235, 0.5)',
  vibrantA300: 'rgba(235, 71, 235, 0.5)',
  vibrantA310: 'rgba(235, 71, 207, 0.5)',
  vibrantA320: 'rgba(235, 71, 180, 0.5)',
  vibrantA330: 'rgba(235, 71, 153, 0.5)'
};
export var colorPalette = _objectSpread(_objectSpread({}, palette), {}, {
  /* Legacy colors, now deprecated */

  /* @deprecated */
  tintOrange: palette.orange500,
  tintGold: palette.gold500,
  tintYellow: palette.yellow500,
  tintGreen: palette.green500,
  tintTeal: palette.teal500,
  tintSkyBlue: palette.skyBlue500,
  tintBlue: palette.blue500,
  tintPurple: palette.purple500,
  tintPink: palette.pink500,

  /** Legacy Alerts */

  /* @deprecated */
  alertError: palette.alertError500,
  alertWarning: palette.alertWarning500,
  alertSuccess: palette.alertSuccess500,

  /** General */
  transparent: 'transparent'
});